import { styled, disabledProps } from "../../../styled-components";
import Img from "../img/img";
import { systemFontFamily } from "common/BaseTheme";

export const BuyScreenWrapper = styled.div`
    display: flex;
    flex-direction: column;

    flex-grow: 1;
`;

const inputHeight = "44px";

export const FormContainer = styled.div<{ disabled?: boolean; testMode: boolean }>`
    padding: ${p => p.theme.pageMarginMedium}px;

    ${p => p.disabled && disabledProps}

    display: grid;

    grid-template-columns: 8fr 3fr 4fr;
    grid-row-gap: 12px;
    grid-column-gap: 4px;
    grid-template-areas:
        "method method method"
        "cc cc billzip"
        ${p => p.testMode && '"testmode testmode testmode"'}
        "name name name"
        "contact contact contact"
        "email email email"
        "phone phone phone"
        "shipping shipping shipping"
        "add1 add1 add1"
        "add2 add2 add2"
        "city state zip"
        "country country country";
`;

export const inputTextSize = "14px";

// This disables autocomplete "banana yellow" highlighting in both Safari and Chrome.
export const StyledInput = styled.input`
    box-shadow: 0 0 0 ${inputHeight} ${p => p.theme.baseColor} inset !important;
    -webkit-box-shadow: 0 0 0 ${inputHeight} ${p => p.theme.baseColor} inset !important;
    background-color: ${p => p.theme.baseColor} !important;
    background-clip: content-box !important;

    font-family: ${systemFontFamily};
    font-size: ${inputTextSize};
    color: ${p => p.theme.fgColorDark};

    :-webkit-autofill {
        font-family: ${systemFontFamily};
        font-size: ${inputTextSize};
        color: ${p => p.theme.fgColorDark};
        -webkit-text-fill-color: ${p => p.theme.fgColorDark};
    }
`;

export const FormHeader = styled.div<{ area: string }>`
    ${p => p.theme.fontStyles.Header4}
    color: ${p => p.theme.fgColorDark};
    grid-area: ${p => p.area};
    padding: 4px 0;
`;

export const InputWrapper = styled.label<{ area: string }>`
    display: flex;
    align-items: center;
    padding: 0 12px;

    height: ${inputHeight};

    grid-area: ${p => p.area};

    border-radius: 4px;
    border: 1px solid ${p => p.theme.separatorColor};

    input {
        width: 100%;
    }

    cursor: text;
`;

export const InfoWrapper = styled.div<{ area: string }>`
    grid-area: ${p => p.area};
    color: ${p => p.theme.fgColorMedium};

    a {
        color: ${p => p.theme.linkColor};
        text-decoration: underline !important;
    }
`;

export const StripeWrapper = styled.div`
    display: flex;
    align-items: center;
    grid-area: cc;

    padding: 0 12px;
    height: ${inputHeight};
    border-radius: 4px;
    border: 1px solid ${p => p.theme.separatorColor};

    box-shadow: 0 0 0 ${inputHeight} ${p => p.theme.baseColor} inset !important;
    -webkit-box-shadow: 0 0 0 ${inputHeight} ${p => p.theme.baseColor} inset !important;
    background-color: ${p => p.theme.baseColor} !important;
    background-clip: content-box !important;

    & > * {
        width: 100%;
    }
`;

export const ButtonArea = styled.div`
    padding: ${p => p.theme.pageMarginMedium}px;
    display: grid;

    grid-column-gap: 34px;
    grid-template-columns: 3fr 5fr;
    grid-template-areas:
        "price button"
        "total button";
`;

export const Spacer = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
`;

export const ButtonWrapper = styled.div`
    grid-area: button;
`;

export const Total = styled.div`
    grid-area: total;

    ${p => p.theme.fontStyles.AccentCallout4}

    color: ${p => p.theme.fgColorMedium};
`;

export const Price = styled.div`
    grid-area: price;

    ${p => p.theme.fontStyles.AccentHeader3}

    color: ${p => p.theme.fgColorDark};
`;

export const HeaderArea = styled.div<{ hasImage: boolean }>`
    display: grid;
    grid-row-gap: 4px;
    grid-column-gap: 12px;
    grid-template-columns: auto 1fr;
    grid-template-areas: ${p => (p.hasImage ? '"pic name" "pic desc"' : '"name" "desc"')};
    padding: ${p => p.theme.pageMarginMedium}px;
`;

export const Name = styled.div`
    grid-area: name;
    ${p => p.theme.fontStyles.AccentCallout4}
    color: ${p => p.theme.fgColorDark};
    align-self: flex-end;
`;

export const Description = styled.div`
    grid-area: desc;
    ${p => p.theme.fontStyles.Body5}
    color: ${p => p.theme.fgColorMedium};
`;

export const HeaderImage = styled(Img)`
    grid-area: pic;
    max-width: 64px;
    height: 64px;
    object-fit: cover;
`;

export const ConfirmationMessage = styled.p`
    position: absolute;
    left: 8%;
    right: 8%;
    bottom: 48.52%;

    ${p => p.theme.fontStyles.Body4}
    text-align: center;
    color: ${p => p.theme.fgColorDark};
`;

export const AuthFrame = styled.iframe`
    width: 100%;
    height: 100%;

    border: 0px;
    flex-grow: 1000;
`;

export const StripeLogo = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;

    color: ${p => p.theme.fgColorMedium};
`;

export const StripeIcon = () => {
    return (
        <svg width="109" height="18" viewBox="0 0 109 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M102.462 10.3755H108.335C108.349 10.2139 108.375 9.58528 108.375 9.29475C108.375 6.22256 106.887 3.79798 104.038 3.79798C101.185 3.79798 99.4478 6.22362 99.4478 9.2789C99.4478 12.8962 101.495 14.726 104.417 14.726C105.851 14.726 106.928 14.4006 107.742 13.9485V11.5323C106.924 11.9444 105.986 12.1958 104.796 12.1958C103.626 12.1958 102.596 11.7817 102.462 10.3755ZM102.436 8.16117C102.436 6.80995 103.269 6.24369 104.019 6.24369C104.756 6.24369 105.537 6.81101 105.537 8.16117H102.436Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M92.4699 13.9675C92.9009 14.2834 93.5422 14.726 94.5923 14.726C96.738 14.726 98.7009 12.9998 98.7009 9.18805C98.7009 5.69539 96.7169 3.79798 94.6103 3.79798C93.4345 3.79798 92.6749 4.35157 92.2607 4.73823L92.1044 3.99765H89.4632L89.4643 18L92.4636 17.3619L92.4699 13.9675ZM92.4604 7.04977C92.7731 6.70642 93.2052 6.45498 93.893 6.45498C94.9906 6.45498 95.746 7.68471 95.746 9.25355C95.746 10.8689 95.0022 12.0764 93.893 12.0764C93.1894 12.0764 92.7699 11.8229 92.4784 11.507L92.4604 7.04977Z"
                fill="currentColor"
            />
            <path d="M88.1384 3.99765H85.1275V14.5116H88.1384V3.99765Z" fill="currentColor" />
            <path d="M88.1384 0L85.1275 0.640216V3.08381L88.1384 2.4436V0Z" fill="currentColor" />
            <path
                d="M81.9169 14.5116V7.38361C82.6258 6.45287 83.8228 6.63247 84.2041 6.75607V3.99871C83.8048 3.85503 82.4029 3.59303 81.7003 4.88402L81.5123 3.99765H78.9187V14.5116H81.9169Z"
                fill="currentColor"
            />
            <path
                d="M77.764 11.8873C77.3805 12.0405 75.4873 12.5909 75.4873 10.8235V6.55535H77.765V3.99765H75.4873L75.4852 1.39242L72.5567 2.01573L72.5429 11.639C72.5429 13.415 73.8793 14.726 75.6595 14.726C76.6399 14.726 77.3646 14.5485 77.764 14.3288V11.8873Z"
                fill="currentColor"
            />
            <path
                d="M67.5353 14.726C70.0296 14.726 71.7485 13.4942 71.7485 11.3348C71.7485 9.11893 69.9887 8.52213 68.6494 8.0679C67.8265 7.78884 67.1624 7.56359 67.1624 7.04977C67.1624 6.58176 67.5532 6.40005 68.1818 6.40005C69.0936 6.40005 70.2525 6.67895 71.1653 7.17232V4.34628C70.1712 3.95011 69.1781 3.79798 68.184 3.79798C65.7509 3.79798 64.1293 5.0689 64.1293 7.19239C64.1293 9.19678 65.7908 9.79489 67.1078 10.269C67.9726 10.5803 68.6889 10.8382 68.6889 11.4056C68.6889 11.9602 68.2072 12.1398 67.5385 12.1398C66.5443 12.1398 65.2618 11.7288 64.255 11.1816V14.0457C65.3706 14.5253 66.501 14.726 67.5353 14.726Z"
                fill="currentColor"
            />
            <path
                d="M53.6936 15.0091H55.0723L58.2301 7.0159H56.7732L55.4283 10.6628L54.094 7.0159H52.6372L54.7607 12.3743L53.6936 15.0091Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.368 12.1852C48.8117 12.5306 49.3019 12.7081 49.7794 12.7081C51.269 12.7081 52.2917 11.5069 52.2917 9.79545C52.2917 8.08292 51.269 6.88278 49.7794 6.88278C49.3019 6.88278 48.8117 7.06027 48.368 7.39411V4.58075H46.945V12.575H48.368V12.1852ZM48.368 8.60587C48.7008 8.27203 49.0906 8.10511 49.4794 8.10511C50.2802 8.10511 50.8359 8.79498 50.8359 9.79545C50.8359 10.7959 50.2802 11.4847 49.4794 11.4847C49.0906 11.4847 48.7008 11.3178 48.368 10.985V8.60587Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.7726 12.7081C40.2618 12.7081 40.7509 12.5306 41.1841 12.1852V12.575H42.6187V4.58075H41.1841V7.39411C40.7509 7.06027 40.2618 6.88278 39.7726 6.88278C38.2936 6.88278 37.2604 8.08292 37.2604 9.79545C37.2604 11.5069 38.2936 12.7081 39.7726 12.7081ZM40.0843 8.10511C40.4731 8.10511 40.8618 8.27203 41.1841 8.60587V10.985C40.8618 11.3178 40.4731 11.4847 40.0843 11.4847C39.2719 11.4847 38.7162 10.7959 38.7162 9.79545C38.7162 8.79498 39.2719 8.10511 40.0843 8.10511Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.4016 11.6073C33.4687 11.6073 32.801 11.0294 32.7123 10.1842H36.4807C36.5029 9.99512 36.5029 9.81764 36.5029 9.66128C36.5029 8.02799 35.514 6.88278 34.0572 6.88278C32.4672 6.88278 31.3114 8.07236 31.3114 9.75108C31.3114 11.4847 32.4894 12.7081 34.1681 12.7081C34.7914 12.7081 35.4253 12.5634 36.0581 12.275V11.0843C35.4802 11.4182 34.914 11.6073 34.4016 11.6073ZM32.7123 9.26194C32.7789 8.49494 33.3124 7.98256 34.0022 7.98256C34.6361 7.98256 35.0914 8.50551 35.1358 9.26194H32.7123Z"
                fill="currentColor"
            />
            <path
                d="M28.965 12.575V8.86154C29.3316 8.39458 29.8324 8.13892 30.2993 8.13892C30.4663 8.13892 30.6437 8.1611 30.799 8.20547V6.93772C30.6437 6.89335 30.4884 6.88278 30.3321 6.88278C29.8546 6.88278 29.3654 7.12683 28.965 7.5716V7.0159H27.542V12.575H28.965Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.306 11.6073C23.3721 11.6073 22.7055 11.0294 22.6167 10.1842H26.3851C26.4073 9.99512 26.4073 9.81764 26.4073 9.66128C26.4073 8.02799 25.4174 6.88278 23.9616 6.88278C22.3716 6.88278 21.2159 8.07236 21.2159 9.75108C21.2159 11.4847 22.3938 12.7081 24.0725 12.7081C24.6948 12.7081 25.3287 12.5634 25.9626 12.275V11.0843C25.3847 11.4182 24.8174 11.6073 24.306 11.6073ZM22.6167 9.26194C22.6833 8.49494 23.2168 7.98256 23.9056 7.98256C24.5395 7.98256 24.9959 8.50551 25.0403 9.26194H22.6167Z"
                fill="currentColor"
            />
            <path
                d="M16.5114 8.79498L17.6461 12.575H18.9244L20.825 7.0159H19.4019L18.2789 10.7959L17.1559 7.0159H15.867L14.744 10.7959L13.621 7.0159H12.1979L14.1101 12.575H15.3884L16.5114 8.79498Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.08205 9.79545C6.08205 11.4964 7.27163 12.7081 8.95035 12.7081C10.6291 12.7081 11.8081 11.4964 11.8081 9.79545C11.8081 8.08292 10.6291 6.88278 8.95035 6.88278C7.27163 6.88278 6.08205 8.08292 6.08205 9.79545ZM7.53891 9.79545C7.53891 8.77279 8.1168 8.07236 8.95035 8.07236C9.77333 8.07236 10.3512 8.77279 10.3512 9.79545C10.3512 10.8181 9.77333 11.5185 8.95035 11.5185C8.1168 11.5185 7.53891 10.8181 7.53891 9.79545Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.42305 9.8282H2.70137C4.2586 9.8282 5.37 8.82773 5.37 7.38249C5.37 5.93725 4.2586 4.92516 2.70137 4.92516H0V12.575H1.42305V9.8282ZM1.42305 6.08199H2.5017C3.32469 6.08199 3.90257 6.60494 3.90257 7.38249C3.90257 8.14948 3.32469 8.67243 2.5017 8.67243H1.42305V6.08199Z"
                fill="currentColor"
            />
        </svg>
    );
};
